export default __webpack_public_path__ + "a48e3162ff892677e4dda1047b3441a5.png";